/**
 * CustomerActions Context
 * @description 将 useCustomerActions 的返回值通过 Context 共享给子组件，
 *              避免每个子组件独立调用导致状态不一致
 */
import { createContext, useContext } from 'react'
import type { useCustomerActions } from './useCustomerActions'

export type CustomerActionsContextType = ReturnType<typeof useCustomerActions>

export const CustomerActionsContext = createContext<CustomerActionsContextType | null>(null)

export function useCustomerActionsContext () {
  const ctx = useContext(CustomerActionsContext)
  if (!ctx) {
    throw new Error('useCustomerActionsContext must be used within CustomerActionsContext.Provider')
  }
  return ctx
}
